module.exports = __webpack_public_path__ + "7df1d964a2e7027df44e73d67833af83.ttf";